var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 mb-5"},[_c('Uploader',{on:{"upload":_vm.uploader}})],1),_c('div',{staticClass:"col-6"}),_c('div',{staticClass:"col-6"},[_c('button',{staticClass:"btn btn-success w-100",on:{"click":_vm.SubmitData}},[_vm._v("بارگذاری فایــل")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }